import { render, staticRenderFns } from "./TheSnackBar.vue?vue&type=template&id=c5b5f57c"
import script from "./TheSnackBar.vue?vue&type=script&lang=js"
export * from "./TheSnackBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports